import BaseService from "./BaseService";

class PaymentConditionService {
  static async GetPaymentConditions(tennantId, token) {
    try {
      return await BaseService.get("paymentconditions", token, { tennantId, pageSize: 100, page: 1 });
    } catch (error) {
      console.error("There was an error fetching the payment forms!", error);
      throw error;
    }
  }
}

export default PaymentConditionService;
